module.exports = __webpack_public_path__ + "a262559c689563da94171d31bd915e07.png";